import React from 'react';
import { FixedIncomeTradeBuyForm } from './forms/FixedIncomeTradeBuyForm';
import { FixedIncomeTradeSellForm } from './forms/FixedIncomeTradeSellForm';
import { TradeSide } from '../schema';
import type { FixedIncomeTradingAsset } from '@fintronners/internal-core/src/trade/types';
import type { FixedIncomeTradeBreakdown } from '@/hooks/trade/useFixedIncomeTradeBreakdown';

export type BaseFormProps = {
  asset?: FixedIncomeTradingAsset;
  breakdown: FixedIncomeTradeBreakdown;
};

type FixedIncomeTradeFormProps = BaseFormProps & {
  side: TradeSide;
};

/**
 * Fixed Income Trade Form Component
 *
 * This component renders the appropriate trade form based on the trade side (buy/sell).
 * It uses the FixedIncomeTradeBuyForm for buy trades and FixedIncomeTradeSellForm for sell trades.
 */
export const FixedIncomeTradeForm = ({ side, asset, breakdown }: FixedIncomeTradeFormProps) => {
  if (side === TradeSide.BUY) {
    return <FixedIncomeTradeBuyForm asset={asset} breakdown={breakdown} />;
  }

  return <FixedIncomeTradeSellForm asset={asset} breakdown={breakdown} />;
};
